import { render } from "./pay-all.vue?vue&type=template&id=6cd1e4ae&scoped=true&ts=true"
import script from "./pay-all.vue?vue&type=script&lang=ts"
export * from "./pay-all.vue?vue&type=script&lang=ts"

import "./pay-all.vue?vue&type=style&index=0&id=6cd1e4ae&scoped=true&lang=stylus"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd1e4ae"]])

export default __exports__